<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-conversationtopictable(:data='tableItems', :label='tableFields', rowClick, v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const defaultRef = db.ref('defaultFallbackIntentWord')

export default {
  name: 'fallback-table',
  data() {
    return {
      cls: {},
      loading: true,
      tableItems: [
      ],
      tableFields: {
        number: {
          label: 'No',
        },
        messages: {
          label: 'Messages',
          tdClass: 'messagesInTable',
        },
        userId: {
          label: 'User ID',
        },
        timestamp: {
          label: 'Timestamp',
        },
        count: {
          label: 'Count',
        },
      },
    }
  },
  mounted: function() {
    var customs
    defaultRef.limitToLast(1000).once('value', (snapshot) => {
      customs = []
      let number = snapshot.numChildren()
      Object.entries(snapshot.val()).forEach(function([key, val]) {
        customs.unshift({
          number,
          messages: val.messages,
          userId: val.userID,
          timestamp: parseInt(val.timestamp),
          count: val.count,
        })
        number -= 1
      })
      this.tableItems = customs
      this.loading = false
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/fallbackTable.vue?4852b860